import * as ActionTypes from '../../actions/allActions'

const signup = (state = { canSubmit: false, password_match: true, form_errors: {} }, action) => {
	switch (action.type) {
		case ActionTypes.SIGNUP_METACHANGE:
			return { ...state, ...action.changes }
		case ActionTypes.SIGNUP_REQUEST:
			return { ...state, form_errors : {} }
		case ActionTypes.BACKEND_FORM_ERROR:
			return { ...state, form_errors: action.form_errors }
		default:
			return state
	}
}

export default signup


// WEBPACK FOOTER //
// ./src/reducers/metadata/signup.js